import { matchPath } from 'react-router-dom';

export enum SearchParams {}

export enum RouteParams {
  CLIENT_ID = 'clientID',
  AIRCRAFT_ID = 'aircraftID',
}

export enum RoutingViews {
  HOME = 'home',

  CLIENTS = 'clients',
  CLIENTS_VIEW = 'clients-view',
  CLIENTS_VIEW_CONTACTS = 'clients-view-contacts',
  CLIENTS_VIEW_AIRCRAFT = 'clients-view-aircraft',

  INVENTORY = 'inventory',
  INVENTORY_AIRCRAFT = 'inventory-aircraft',

  TRANSACTIONS = 'transactions',
}

const _generatePath = (
  root: RoutingViews,
  ...children: (RoutingViews | RouteParams)[]
) => {
  let path = `/${root}`;
  children.forEach(child => {
    if (Object.values(RouteParams).includes(child as RouteParams)) {
      path = `${path}/:${child}`;
    } else {
      path = `${path}/${child.replaceAll(`${root}-`, '')}`;
    }
  });
  return path;
};

export const RoutingPaths = {
  [RoutingViews.HOME]: `/${RoutingViews.HOME}`,

  [RoutingViews.CLIENTS]: _generatePath(RoutingViews.CLIENTS),
  [RoutingViews.CLIENTS_VIEW]: _generatePath(
    RoutingViews.CLIENTS,
    RoutingViews.CLIENTS_VIEW
  ),
  [RoutingViews.CLIENTS_VIEW_CONTACTS]: _generatePath(
    RoutingViews.CLIENTS,
    RoutingViews.CLIENTS_VIEW_CONTACTS,
    RouteParams.CLIENT_ID
  ),
  [RoutingViews.CLIENTS_VIEW_AIRCRAFT]: _generatePath(
    RoutingViews.CLIENTS,
    RoutingViews.CLIENTS_VIEW_AIRCRAFT,
    RouteParams.CLIENT_ID
  ),

  [RoutingViews.INVENTORY]: `/${RoutingViews.INVENTORY}`,
  [RoutingViews.INVENTORY_AIRCRAFT]: _generatePath(
    RoutingViews.INVENTORY,
    RouteParams.AIRCRAFT_ID
  ),

  [RoutingViews.TRANSACTIONS]: `/${RoutingViews.TRANSACTIONS}`,
};

export const getRouteFromPath = (
  path: RoutingViews,
  replacements: { [key: string]: string }
) => {
  let p = RoutingPaths[path];
  Object.entries(replacements).forEach(([key, val]) => {
    p = p.replace(`:${key}`, val);
  });
  // Logger({ objs: { p } }, getRouteFromPath);
  return p;
};

export const getViewFromPath = (
  path: string,
  exact = true,
  { exclude }: { exclude?: RoutingViews[] } = {}
): RoutingViews | undefined => {
  return getAllViewsFromPath({ path, exact, exclude })[0];
};

export const getAllViewsFromPath = ({
  exclude,
  exact,
  path,
}: {
  path: string;
  exact?: boolean;
  exclude?: RoutingViews[];
}): RoutingViews[] => {
  return Object.values(RoutingViews).filter(view => {
    if (exclude && exclude.includes(view)) return false;
    return matchPath(
      exact ? RoutingPaths[view] : RoutingPaths[view] + '/*',
      path
    );
  });
};

export const isViewActive = (path: string, view: RoutingViews) => {
  return getAllViewsFromPath({ path, exact: false }).includes(view);
};
